import { Div, Icon, Label, Touchable } from "@grassrootly/rn-core";
import { DrawerContentComponentProps } from "@react-navigation/drawer";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSideNav } from "./useSideNav";
import { Platform, Image } from "react-native";
import { images } from "../../assets";
import { useAuth } from "../../../components/guard/useAuth";

export default function SideNav({ navigation }: DrawerContentComponentProps) {
  const insets = useSafeAreaInsets();
  const { logOut } = useSideNav();
  const { user } = useAuth();
  const goHome = () => navigation.jumpTo("home_remastered");
  const goToMyGames = () => navigation.jumpTo("my-games");
  const goToMyGroups = () => navigation.jumpTo("my-groups");
  const goToCompetitions = () => navigation.jumpTo("competitions-list");
  const goToStats = () => navigation.jumpTo("stats");
  const goToProfile = () => navigation.jumpTo("profile");
  const goToEqipaCard = () => navigation.jumpTo("eqipa-card");
  return (
    <Div classNames={["bgSecondaryMain", "flex1"]}>
      <Div
        classNames={["flex1", `pt-{${insets.top + 4 + (Platform.OS == "web" ? 16 : 0)}}`, `pb-{${insets.bottom + 8}}`]}
      >
        <Icon name="arrow_back_ios" size={24} onPress={navigation.toggleDrawer} classNames={["ml-{auto}", "mr-{15}"]} />
        <Div classNames={["m-{20}", "flex1"]}>
          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goHome}>
            <Icon name="home" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Home</Label>
          </Touchable>

          {/* <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToMyGames}>
            <Icon name="sports_soccer" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">My Games</Label>
          </Touchable> */}

          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToMyGroups}>
            <Image
              source={images.groupAvatar}
              style={{ height: 28, width: 28, borderRadius: 6, marginRight: 10 }}
              resizeMode="cover"
            />
            <Label type="l1Regular">My Teams</Label>
          </Touchable>

          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToCompetitions}>
            <Icon name="emoji_events" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Competitions</Label>
          </Touchable>

          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToEqipaCard}>
            <Image
              source={user?.profile_picture ? { uri: user.profile_picture } : images.playerAvatar}
              style={{ height: 28, width: 28, borderRadius: 28, marginRight: 10 }}
              resizeMode="cover"
            />
            <Label type="l1Regular">My Player Profile</Label>
          </Touchable>

          <Div classNames={["borderBottomSolid", "borderSolid", "borderSecondaryLight", "bwBottom-{1}", "mv-{6}"]} />

          {/* <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToStats}>
            <Icon name="analytics" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Monthly Rankings</Label>
          </Touchable> */}

          <Touchable classNames={["flexRow", "mv-{10}", "alignItemsCenter"]} onPress={goToProfile}>
            <Icon name="person" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Account</Label>
          </Touchable>

          <Touchable classNames={["flexRow", "mb-{10}", "mt-{auto}", "alignItemsCenter"]} onPress={logOut}>
            <Icon name="logout" size={28} classNames={["mr-{10}"]} />
            <Label type="l1Regular">Log out</Label>
          </Touchable>

          <Label classNames={["l4Regular"]}>
            {process.env.EXPO_PUBLIC_SUPABASE_ENV} - v{process.env.EXPO_PUBLIC_APP_VERSION}</Label>
        </Div>
      </Div>
    </Div>
  );
}
